import { BoundedContent, Box, H2 } from '@vp/swan';
import { SupportedLocale, __ } from '@99designs/i18n';
import { usePage } from '@99designs/tracking';
import { DesignProduct } from '../../lib/presenter/types';
import { getNavigationData } from '../../lib/tracking';
import { ProductCarousel } from '../ProductCarousel';

interface PopularProductsProps {
    products: DesignProduct[];
    locale: SupportedLocale;
    title?: string;
    maxSlides?: number;
}

export function PopularProducts({
    products,
    locale,
    title = __('Popular Products'),
    maxSlides = 4,
}: PopularProductsProps) {
    const { pageData } = usePage();

    return (
        <BoundedContent data-testid="popular-products">
            <Box paddingLeft={{ xs: 3, md: 0 }} paddingRight={{ xs: 3, md: 0 }}>
                <H2 marginBottom="6" data-testid="popular-products-title">
                    {title}
                </H2>
                <ProductCarousel
                    products={products}
                    locale={locale}
                    productClickedTrackingData={(product, index) => {
                        return getNavigationData(product, {
                            pageName: pageData.pageName,
                            pageStage: pageData.pageStage,
                            pageSection: pageData.pageSection,
                            pagePath: pageData.pagePath ?? window.location.pathname,
                            pageZone: 'Popular Product Tiles',
                            position: index,
                        });
                    }}
                    maxSlides={maxSlides}
                />
            </Box>
        </BoundedContent>
    );
}
